import api from "../api";
import { ENDPOINTS } from "../endpoints";
/*
|--------------------------------------------------------------------------
| ADMIN APIs (School Web)
|--------------------------------------------------------------------------
*/

/**
 * Get all appointments (Admin)
 */
export const getAppointments = (params = {}) =>
  api.get(ENDPOINTS.APPOINTMENT.GET, { params });

/**
 * Get appointment detail
 */
export const getAppointment = (id) =>
  api.get(`${ENDPOINTS.APPOINTMENT.GET}/${id}`);

/**
 * Reply / Schedule meeting
 */
export const replyAppointment = (id, data) =>
  api.post(`${ENDPOINTS.APPOINTMENT.REPLY}/${id}`, data);

/**
 * Close appointment
 */
export const closeAppointment = (id) =>
  api.post(`${ENDPOINTS.APPOINTMENT.CLOSE}/${id}`);

/**
 * Cancel appointment (Admin)
 */
export const cancelAppointment = (id) =>
  api.post(`${ENDPOINTS.APPOINTMENT.CANCEL}/${id}`);

/**
 * Parent create appointment
 */
export const createAppointment = (data) =>
  api.post(ENDPOINTS.PARENT.APPOINTMENT.CREATE, data);

/**
 * Parent get own appointments
 */
export const getParentAppointments = (params = {}) =>
  api.get("/parent/appointments", { params });

/**
 * Parent confirm appointment
 */
export const confirmAppointment = (id) =>
  api.post(`/parent/appointments/${id}/confirm`);

/**
 * Parent cancel appointment
 */
export const parentCancelAppointment = (id) =>
  api.post(`/parent/appointments/${id}/cancel`);

/**
 * Parent reschedule appointment
 */
export const rescheduleAppointment = (id, data) =>
  api.post(`/parent/appointments/${id}/reschedule`, data);